<template>
    <div>
        <div class="item-wrapper">
            <div class="container-fluid" style="position: relative">
                <div :class="[blog === true ? 'row justify-content-center' : 'row']" v-if="!loading || !loadingMore">
                    <product-card
                        v-for="product in items"
                        :key="product.id"
                        :coloredProduct="product"
                        :watchdog="false"
                        :currency-symbol="currencySymbol"
                        :gant="gant"
                        :vermont="vermont"
                        :stickers="stickers"
                        :thumbnails="thumbnails"
                        :watchdogVariants="watchedItems"
                        :redirectToProduct="redirectToProduct"
                        :by-model-id="byModelId"
                    />
                </div>
                <div v-if="loading || globalLoading" class="spinnerOverlay">
                    <div class="spinnerWrapper">
                        <span v-if="gant == true">
                            <spinner-gant />
                        </span>
                        <span v-else>
                            <spinner-vermont />
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="nextPage" class="content-wrapper">
            <div class="content-inner">
                <div class="subcategories-bottom-button" v-if="nextPage">
                    <button
                        class="text-uppercase shop-button spinnerButton"
                        @click="loadMore"
                        :class="loadingMore ? 'spinnerNoBorder' : ''"
                    >
                        <span>{{ __('frontend_js.colored_product.load_more') }} ({{ itemsOnNextPageCount }})</span>
                        <div v-if="loadingMore" class="spinnerButtonOverlay">
                            <span v-if="gant == true">
                                <spinner-gant />
                            </span>
                            <span v-else>
                                <spinner-vermont />
                            </span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import productCard from './card/product-card.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
    components: { productCard },
    props: {
        itemsFromView: { default: () => window.coloredProducts }, // if coloredProducts is sent to multiple components, it takes a lot of text in HTML, so by default it is saved into a global variable, but be sure it is initialized or send the props,
        user: {},
        cpInWishlist: {},
        byModel: { required: false }, // Ked nema hodnotu, nezobrazi sa Load More button
        byModelId: { required: false }, // Ked nema hodnotu, nezobrazi sa Load More button
        currencySymbol: {},
        wishlist: {},
        gant: { type: Boolean },
        vermont: { type: Boolean },
        stickers: {},
        thumbnails: {},
        numberOfDecimals: 0,
        blog: {
            default: false,
            type: Boolean,
        },
        watchdogVariants: {},
        redirectToProduct: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            itemsOnNextPageCount: null,
            loadingMore: false,
            watchedItems: this.watchdogVariants,
            previousScrollPerformed: false,
            initialLoad: false,
        };
    },
    computed: {
        baseUrl() {
            if (!this.byModel || !this.byModelId) return null;
            if (this.byModel == 'category' && this.check == true) return `category-auth/${this.byModelId}`;
            if (this.byModel == 'category' && this.check == false) return `category/${this.byModelId}`;
            if (this.byModel == 'trademark' && this.check == true) return `trademarks-auth/${this.byModelId}`;
            else if (this.byModel == 'trademark' && this.check == false) return `trademarks/${this.byModelId}`;
        },
        items() {
            return this.$store.getters['product-list/coloredProducts'];
        },
        orderString() {
            return this.$store.getters['product-filters/orderString'];
        },
        ...mapGetters({
            globalLoading: 'product-list/loading',
            nextPage: 'product-list/nextPage',
            check: 'auth/check',
        }),
    },
    methods: {
        ...mapMutations({ setNextPage: 'product-list/SET_NEXT_PAGE' }),
        loadMore() {
            this.loadingMore = true;

            this.updateUrlParameter();

            this.$store
                .dispatch('product-list/fetchColoredProducts', {
                    url: this.baseUrl,
                    page: this.nextPage,
                    merge: true,
                })
                .then(res => {
                    this.countItemsOnNextPage(res.data.meta);
                    this.resolveNextPageLink(res.data.links.next);
                    this.watchdogVariantsUpdated(res.data.watchdogVariants);
                    this.$root.$emit('itemsLoaded', res.data.meta);
                    // this.$root.$emit('exponeaViewCategoryEvent', res.data.exponeaEventData);
                })
                .catch(e => {
                    console.log(e);
                })
                .finally(() => {
                    this.loadingMore = false;
                });
        },
        resolveNextPageLink(nextPagelink) {
            if (nextPagelink) {
                var url = new URL(nextPagelink);
                this.setNextPage(url.searchParams.get('page'));
            } else {
                this.setNextPage(null);
            }
        },
        updateUrlParameter() {
            if (this.nextPage) {
                window.history.pushState(null, null, '?' + this.orderString + `page=${this.nextPage}`);
            }
        },
        countItemsOnNextPage(items) {
            this.itemsOnNextPageCount = items.total - items.to > items.per_page ? items.per_page : items.total - items.to;
        },
        updateProductsByFilter(res) {
            this.countItemsOnNextPage(res.data.meta);
            this.resolveNextPageLink(res.data.links.next);
            this.watchdogVariantsUpdated(res.data.watchdogVariants);
            this.$root.$emit('itemsLoaded', res.data.meta);
            // this.$root.$emit('exponeaViewCategoryEvent', res.data.exponeaEventData);
            this.$root.$emit('datalayerViewCategoryEvent', res.data.datalayerEventData);
        },
        countItemsOnNextPage(items) {
            this.itemsOnNextPageCount = items.total - items.to > items.per_page ? items.per_page : items.total - items.to;
        },
        watchdogVariantsUpdated(items) {
            if (this.watchedItems.length > 0) {
                this.watchdogVariants.push(items);
            } else {
                this.watchedItems = items;
            }
        },
        initializeItemsFromView() {
            if (this.itemsFromView.data) {
                this.removeSticker(this.itemsFromView.data);
                this.$store.commit('product-list/SET_COLORED_PRODUCTS', this.itemsFromView.data);
                console.log(' som v initiazle hore');
            } else {
                this.removeSticker(this.itemsFromView);
                this.$store.commit('product-list/SET_COLORED_PRODUCTS', this.itemsFromView);
            }
        },
        removeSticker(items) {
            items.forEach(item => {
                if (item.final_basic_price_number > 0 && item?.cms_stickers) {
                    if (item.final_sale_price_number > 0) {
                        const descreasedPercentage =
                            (Math.abs(item.final_basic_price_number - item.final_sale_price_number) /
                                item.final_basic_price_number) *
                            100;
                        if (descreasedPercentage !== undefined && 50 > descreasedPercentage && descreasedPercentage != 0) {
                            const indexOfSticker = item.cms_stickers.findIndex(sticker => sticker.code === 'stUniv1');
                            if (indexOfSticker >= 0) {
                                item.cms_stickers.splice(indexOfSticker, 1);
                            }
                        }
                    }
                }
            });
        },
        removeProductListBladeLoader() {
            setTimeout(function () {
                if (document.getElementById('forced-loader')) {
                    document.getElementById('forced-loader').remove();
                }
            }, 300);
        },
    },

    async mounted() {
        this.initializeItemsFromView();

        this.$root.$on('filtered-products-fetched', this.updateProductsByFilter);
        this.$root.$on('paginated-products-fetched', this.updateProductsByFilter);

        this.$store.commit('auth/SET_USER', this.user);
        this.$store.commit('auth/SET_WISHLIST', this.wishlist);
        this.$store.commit('product-list/SET_CURRENCY_SYMBOL', this.currencySymbol);
        this.$store.commit('product-list/SET_NUMBER_OF_DECIMALS', this.numberOfDecimals);

        this.loading = false;
        this.loadingMore = false;

        if (this.itemsFromView.next_page_url) {
            this.setNextPage(this.itemsFromView.current_page + 1);
            this.countItemsOnNextPage(this.itemsFromView);
        } else {
            this.itemsOnNextPageCount = 0;
        }

        this.removeProductListBladeLoader();

        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
    },

    updated: function () {
        if (this.previousScrollPerformed == false) {
            //handles scroll to specific product on product list page
            this.$nextTick(function () {
                let currentCategoryLastPosition = localStorage.getItem('category-' + this.byModelId);
                if (currentCategoryLastPosition) {
                    let previousDiv = document.getElementById('product-' + currentCategoryLastPosition);
                    if (previousDiv) {
                        $('html, body').animate(
                            { scrollTop: $('#product-' + currentCategoryLastPosition).offset().top },
                            'smooth'
                        );
                        // document.getElementById("product-" + currentCategoryLastPosition).scrollIntoView({behavior: 'smooth'});
                        // let divOffset = $('#product-' + currentCategoryLastPosition).offset();
                        // window.scroll({
                        //     top: divOffset.top,
                        //     left: divOffset.left,
                        //     behavior: 'smooth',
                        // });
                        this.previousScrollPerformed = true;
                        this.initialLoad = true;
                        localStorage.removeItem('category-' + this.byModelId);
                    }
                }
            });
        }
        //handles scroll to top of product list page on coming back
        if (this.initialLoad == false) {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
            this.initialLoad = true;
        }
    },
};
</script>

<style lang="scss" scoped></style>
